import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';

import * as UserDataConfig from '../../config/user-data.config';
import { CurrencyFunctionalityService, SERVICE_END_POINT } from 'src/app/shared';
import { AnalyticsService, FormValidationsService, QuoteDataCaptureService, ProductCodeValidators } from 'src/app/shared';

import { AppState } from '../../../../store/state/app.state';
import { YourPension, RefNo } from '../../../../model/ngrx';
import * as YourPensionActions from '../../../../store/actions/your-pension.actions';
import * as RefNumberActions from '../../../../store/actions/reference-number.actions';
import { AlertModal } from 'src/app/model/alert';
import { UtilService } from '../../../../shared';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Component({
  selector: 'app-your-pension',
  templateUrl: './your-pension.component.html',
  styleUrls: ['./your-pension.component.scss']
})
export class YourPensionComponent implements OnInit, OnDestroy {

  public contentData: object;
  protected cmsAlertData: any;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public userForm: UntypedFormGroup;
  public yourPensionForm: UntypedFormGroup;
  protected sourcesCvt = this.userInputDetail.sourcesListCvt;
  public sourcesConfiguration = [];
  protected fundAttributes = this.userInputDetail.fundAttributes;

  public totalFundAmount = 0;
  public manualSourceSelection = false;
  public manualSourceConfig;
  public pensionPotErrorValidatorFlag = false;
  public displayAlert = false;
  public displayEditAlert = false;
  public alertModalConfig: AlertModal = new AlertModal('alert', 'A message you should pay attention to', '', 'OK', '', '');
  private subscriptn: Subscription;
  private subscripBeforeLogin: Subscription;
  private subscripSaveProgress: Subscription;

  yourPensionStore: Observable<YourPension[]>;
  pensionForm: YourPension;
  referenceNumberStore: Observable<RefNo[]>;
  referenceNumber: RefNo;
  editMode: boolean;
  pensionFormEdit: YourPension;
  QuoteAffectingValues: any;
  // tslint:disable-next-line:max-line-length
  public alertModalEditConfig: AlertModal;
  private CMSData;

  constructor(private fb: UntypedFormBuilder, private activatedRoute: ActivatedRoute, private router: Router,
              private store: Store<AppState>, private quoteDatacaptureService: QuoteDataCaptureService, private analyticsService: AnalyticsService,
              public el: ElementRef,
              private utilService: UtilService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.yourPension;
    this.cmsAlertData = this.activatedRoute.snapshot.data.contentData;
    this.manualSourceConfig = this.contentData['manualSourceSelection'];
    this.yourPensionStore = store.select(STORE_VAL.your_pension);
    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.yourPensionStore.subscribe((val) => {
      if (val.length > 0) {
        this.pensionForm = val[0];
        this.pensionForm = this.formatNumbersToCurrencies(this.pensionForm);
      } else if (this.yourPensionForm) {
        this.yourPensionForm.reset();
      }
    });
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        if (this.referenceNumber && this.referenceNumber.editMode) {
          this.editMode = true;
          this.userInputDetail['buttonConfig']['label'] = 'Done';
          this.userInputDetail['buttonConfig']['name'] = 'Done';
          this.pensionFormEdit = JSON.parse(JSON.stringify(this.pensionForm));
          //console.log(this.pensionFormEdit);
        } else {
          this.editMode = false;
        }
      }
    });
  }

  ngOnInit() {
    this.GetCMSDataService();
    // this.alertModalEditConfig.setContent(this.cmsAlertData.generalConstants.quoteChangeWarning);
    this.userFormData();
    this.setSourcesConfiguration();
    this.setYourPensionForm();
    if (this.pensionForm) {
      this.updateTotalFund('');
    }
    // tslint:disable-next-line:max-line-length
    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
  }

  userFormData = () => {
    // this.userInputDetail.buttonConfig.label = 'Next';
    this.userForm = this.fb.group({
      next: ['']
    });
  }
  ngOnDestroy() {

    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
    this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
  }
    createQuestionarray(): any {
      const questionArray = [];
      if (this.yourPensionForm.controls.guarantees.value) {
        questionArray.push({
          questionCode: 'guaranteesQuestion',
          // question: this.contentData['guaranteesQuestion'].questionStatement,
          questionType: this.contentData['guaranteesQuestion'].questionType,
          answer: this.yourPensionForm.controls.guarantees.value
        });
      }
      if (this.yourPensionForm.controls.penalties.value) {
        questionArray.push({
          questionCode: 'penaltiesQuestion',
          // question: this.contentData['penaltiesQuestion'].questionStatement,
          questionType: this.contentData['penaltiesQuestion'].questionType,
          answer: this.yourPensionForm.controls.penalties.value
        });
      }
      return questionArray;
    }
  saveAfterLogin() {
  this.saveFormValues();
  this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully());
}
  saveProgress() {
    this.saveFormValues();
    this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
  }
  saveFormValues() {
    this.store.dispatch(new YourPensionActions.RemoveYourPension(0));
    // tslint:disable-next-line:max-line-length
    this.store.dispatch(new YourPensionActions.AddYourPension({...this.yourPensionForm.value, totalSum: this.totalFundAmount , riskAndStaticQuestion: this.createQuestionarray() }));
  }
  setYourPensionForm() {
    if (this.pensionForm) {
      this.yourPensionForm = this.fb.group({
        guarantees: [this.pensionForm.guarantees, Validators.required],
        penalties: [this.pensionForm.penalties, Validators.required],
        manualSource: [this.pensionForm.manualSource]
      });
    } else {
      this.yourPensionForm = this.fb.group({
        guarantees: [null, Validators.required],
        penalties: [null, Validators.required],
        manualSource: [null]
      });
    }
    this.sourcesCvt.forEach((item) => {
      let tempFormGroup = this.fb.group({});
      this.fundAttributes.forEach(element => {
        if (element === 'productCode') {
          tempFormGroup.addControl(element, this.fb.control(null,
            [ProductCodeValidators.productCodeValidator(item.productCodeValidationRule)]));
        } else if (element === 'transferType') {
          tempFormGroup.addControl(element, this.fb.control(item.code));
        } else {
          tempFormGroup.addControl(element, this.fb.control(null));
        }
      });
      if (this.pensionForm) {
        tempFormGroup.controls['fundValue'].setValue(this.pensionForm[item.controlName].fundValue);
        tempFormGroup.controls['productCode'].setValue(this.pensionForm[item.controlName].productCode);
        tempFormGroup.controls['transferType'].setValue(this.pensionForm[item.controlName].transferType);
      }
      this.yourPensionForm.addControl(item.controlName, tempFormGroup);
    });
  }


  setSourcesConfiguration() {
    this.contentData['sourcesList'].forEach(source => {
      let item = {};
      item['config'] = source;
      item['controlName'] = this.getSourceControlName(source.sourceName);
      this.sourcesConfiguration.push(item);
    });
  }

  getSourceControlName(src: string): string {
    let srcControlName = '';
    srcControlName = this.sourcesCvt.filter(source => {
      return source['value'] === src;
    })[0]['controlName'];
    return srcControlName;
  }

  updateTotalFund(flag) {
    let totalFund = 0;
    let fundArray = [];
    this.sourcesCvt.forEach(element => {
      let fund = Object.assign({}, this.yourPensionForm.get(element.controlName).value);
      fund['fundValue'] = CurrencyFunctionalityService.convertCurrencyToNumber(fund['fundValue']);
      fundArray.push(fund);
    });
    fundArray.forEach(element => {
      totalFund += element['fundValue'];
    });
    this.totalFundAmount = totalFund;
    this.checkMajorFundContributor(fundArray);
    this.validateRules();
  }

  checkMajorFundContributor(fundArray) {

    const maxFund = Math.max.apply(Math, fundArray.map(function (fund) { return fund.fundValue; }));
    const maxFundSources = fundArray.filter(element => {
      return element.fundValue === maxFund;
    });
    if (maxFundSources.length > 1) {
      if (maxFundSources.filter(element => { return element.transferType === 'Int.' }).length <= 0) {
        this.manualSourceSelection = true;
        this.yourPensionForm.controls['manualSource'].setValidators(Validators.required);
        this.manualSourceConfig = Object.assign({}, this.contentData['manualSourceSelection']);
        this.manualSourceConfig.questionOptions = [];
        if (!(maxFundSources.length === 2 && maxFundSources.filter(element => { return element.transferType === 'Ext' }).length > 0)) {
          maxFundSources.forEach((element) => {
            if (element.transferType !== 'Ext') {
              let option = {};
              option['label'] = this.sourcesCvt.filter(temp => { return temp.code === element.transferType })[0].value;
              option['code'] = element.transferType;
              this.manualSourceConfig.questionOptions.push(option);
            }
          });
        } else {
          this.manualSourceSelection = false;
          this.yourPensionForm.controls['manualSource'].clearValidators();
        }
        //console.log(JSON.stringify(this.manualSourceConfig.questionOptions));
      } else {
        this.manualSourceSelection = false;
        this.yourPensionForm.controls['manualSource'].clearValidators();
      }
    } else {
      this.manualSourceSelection = false;
      this.yourPensionForm.controls['manualSource'].clearValidators();
    }
    this.yourPensionForm.controls['manualSource'].updateValueAndValidity();
  }

  validatePensionPot(): boolean {
    let pensionPotValidator = false;
    if (this.totalFundAmount > 0) {
      pensionPotValidator = true;
    }
    return pensionPotValidator;
  }

  validateRules(): boolean {
    let rulesValid = false;
    this.pensionPotErrorValidatorFlag = this.validatePensionPot() ? false : true;
    if (!this.yourPensionForm.valid) {
      FormValidationsService.validateAllFormFields(this.yourPensionForm, this.analyticsService);
    }

    if (this.yourPensionForm.valid && !this.pensionPotErrorValidatorFlag) {
      rulesValid = true;
    }

    return rulesValid;
  }


  validateProductCode(productCodeData) {
    // let isValidProductCode = false;
    if(productCodeData['event']!= '' && productCodeData['event'] != null && (productCodeData['event'] == 'sunLife' || productCodeData['event'] == 'aegon' || productCodeData['event'] == 'phoenixLife') ) {
      let getRegex = this.sourcesCvt.filter(element => {
        return element.controlName === productCodeData['event'];
      })[0].productCodeValidationRule;
      let productCodeValue = this.yourPensionForm.get(productCodeData['event']).get('productCode').value[0];
      let statusRegex =  (getRegex).test(productCodeValue);
      if(statusRegex == false) {
      // this.yourPensionForm.get(productCodeData['event']).get('productCode').status = 'INVALID';
        this.yourPensionForm.get(productCodeData['event']).get('productCode').setErrors({invalidText: true});
      } else {
      //  this.yourPensionForm.get(productCodeData['event']).get('productCode').status = 'VALID';
        this.yourPensionForm.get(productCodeData['event']).get('productCode').setErrors(null);
      }
      
    }
    
    const isValidProductCode = this.yourPensionForm.get(productCodeData['event']).get('productCode').valid;
   // //console.log(productCodeValue)
    if (!isValidProductCode) {
      this.displayAlert = true;
      let formattedSourceName = this.sourcesCvt.filter(element => {
        return element.controlName === productCodeData['event'];
      })[0].value;
      this.alertModalConfig.setContent(this.contentData['sourcesList'].filter(source => {
        return source.sourceName === formattedSourceName;
      })[0].productCodeErrorMsg);
    }
  }

  alertPrimaryBtnClick() {
    this.closeModal();
  }

  alertSecondaryBtnClick() {
    this.closeModal();
  }

  closeModal() {
    this.displayAlert = false;
    this.displayEditAlert = false;
  }
  gotoNext = () => {
    let formchanged = false;

    if (this.validateRules()) {
      if (this.editMode || this.userInputDetail.buttonConfig.name.toUpperCase() !== 'NEXT') {
        this.referenceNumber.editMode = false;
        this.store.dispatch(new RefNumberActions.RemoveReferenceNumber(0));
        this.store.dispatch(new RefNumberActions.AddReferenceNumber(this.referenceNumber));
        this.editMode = false;

        for (const val of this.sourcesCvt) {
          if (this.yourPensionForm.get(val.controlName).value.fundValue !== this.pensionForm[val.controlName].fundValue) {
            formchanged = true;
            break;
          }
          if (this.yourPensionForm.get(val.controlName).value.productCode !== this.pensionForm[val.controlName].productCode) {
            formchanged = true;
            break;
          }
        }
        if (!formchanged) {
          if (this.yourPensionForm.get('guarantees').value !== this.pensionForm['guarantees']) {
            formchanged = true;
          }
          if (this.yourPensionForm.get('penalties').value !== this.pensionForm['penalties']) {
            formchanged = true;
          }
        }
        if (formchanged) {
          this.store.dispatch(new YourPensionActions.RemoveYourPension(0));
          // tslint:disable-next-line:max-line-length
          this.store.dispatch(new YourPensionActions.AddYourPension({ ...this.yourPensionForm.value, totalSum: this.totalFundAmount , riskAndStaticQuestion: this.createQuestionarray() }));
          this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
            this.router.navigate(['/quote/your-product-choice'], { replaceUrl: true });
          });
        } else {
          this.router.navigate(['/quote/please-confirm-your-details'], { replaceUrl: true });
        }
      } else {
        // this.annuitantService.postAnnuitantDetail(this.dependantDetailForm.value);
        this.store.dispatch(new YourPensionActions.RemoveYourPension(0));
        // tslint:disable-next-line:max-line-length
        this.store.dispatch(new YourPensionActions.AddYourPension({ ...this.yourPensionForm.value, totalSum: this.totalFundAmount, riskAndStaticQuestion: this.createQuestionarray()  }));
        this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
          this.router.navigate(['/home/your-product-choice']);
        });
      }
    } else {
      FormValidationsService.validateAllFormFields(this.yourPensionForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      });
    }
  }

  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }
  gotoNextPage() {
    if (this.validateRules()) {
      this.store.dispatch(new YourPensionActions.RemoveYourPension(0));
      // tslint:disable-next-line:max-line-length
      this.store.dispatch(new YourPensionActions.AddYourPension({ ...this.yourPensionForm.value, totalSum: this.totalFundAmount , riskAndStaticQuestion: this.createQuestionarray() }));
      this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
        this.router.navigate(['/home/your-product-choice']);
      });
    }
  }
  OnBackClick() {
    this.store.dispatch(new YourPensionActions.RemoveYourPension(0));
    // tslint:disable-next-line:max-line-length
    this.store.dispatch(new YourPensionActions.AddYourPension({ ...this.yourPensionForm.value, totalSum: this.totalFundAmount , riskAndStaticQuestion: this.createQuestionarray() }));
  }

  formatNumbersToCurrencies(formData) {
    this.sourcesCvt.forEach((item) => {
      let sourceData = formData[item.controlName];
      sourceData['fundValue'] = CurrencyFunctionalityService.convertNumberToCurrency(sourceData['fundValue']);
      formData[item.controlName] = sourceData;
    });
    return formData;
  }

  showChangeAlert = () => {
    if (this.yourPensionForm.valid) {
      let formchanged = false;
      if (this.editMode) {
        //console.log(this.editMode)
        for (let val of this.sourcesCvt) {
          if (this.yourPensionForm.get(val.controlName).value.fundValue !== this.pensionFormEdit[val.controlName].fundValue) {
            //console.log(this.pensionFormEdit[val.controlName] + "popup");
            this.pensionFormEdit[val.controlName] = this.yourPensionForm.controls[val.controlName].value;
            formchanged = true;
            break;
          }
        }
        // formchanged=true;
        if (formchanged) {
          //console.log('yes');
          this.displayEditAlert = true;
        } else {
        }
      }
    }
  }
  txtChange = () => {
    this.validateRules();
    this.showChangeAlert();
  }

  /** Code block for CMS */
GetCMSDataService() {
  const URL =  SERVICE_END_POINT.higherEnvironment.CMS_YourPensionSavings;
  this.utilService.getCMSData(URL)
  .subscribe(res => {
    //console.log('2 GetCMSDataService => ', res);
    this.CMSData = res;
    if (this.CMSData) {
    /** In the line below we are over-writing the contentData object values with CMSData object values */
    this.alertModalEditConfig = new AlertModal('alert', this.CMSData.commonBlock.string_DependantRemovedPopUpTitle, this.CMSData.commonBlock.string_DependantRemovedPopUpText, this.CMSData.commonBlock.string_OKCTALabel, '', 'Don’t show this message again');
      }
  });
}

}
